export default "__VITE_ASSET__C52mCND4__"